import { inject, Injectable, signal } from '@angular/core';
import { ConfigurationService } from '../services/configuration.service';
import { shareReplay } from 'rxjs';

export interface CartConfig {
  active: boolean;
  startDate?: string;
  endDate?: string;
}

@Injectable({
  providedIn: 'root'
})
export class CartConfigStore {
  private configService = inject(ConfigurationService);

  cartConfig = signal<CartConfig | null>(null);
  isLoaded = signal<boolean>(false);

  private fetchObservable: any = null;

  loadConfig(): void {
    // Si le chargement a déjà démarré ou est terminé, on ne relance pas la requête
    if (this.isLoaded() || this.fetchObservable) return;

    this.fetchObservable = this.configService.getPublicConfigOrder().pipe(
      shareReplay(1) // Évite de dupliquer les appels HTTP en parallèle
    );

    this.fetchObservable.subscribe({
      next: (res: any) => {
        const cartData = res.body?.data?.cart;
        if (cartData) {
          this.cartConfig.set(cartData);
        }
        this.isLoaded.set(true);
      },
      error: () => {
        this.isLoaded.set(true);
      }
    });
  }
}
